import { Component, ChangeDetectionStrategy, ElementRef, Renderer2, Input } from '@angular/core';
import { CardBackgroundComponent } from '../../card-background.component';
import { PlainJanePostCardStackBackgroundViewModel } from './plain-jane-post-card-stack-background-view-model';
import type { CardData } from '../../../../../../../models/print-cards/card-data';

@Component({
  selector: 'app-plain-jane-post-card-stack-background',
  templateUrl: './plain-jane-post-card-stack-background.component.html',
  styleUrls: ['./plain-jane-post-card-stack-background.component.scss'],
  providers: [PlainJanePostCardStackBackgroundViewModel],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class PlainJanePostCardStackBackgroundComponent extends CardBackgroundComponent {
  constructor(
    public viewModel: PlainJanePostCardStackBackgroundViewModel,
    elementRef: ElementRef,
    renderer2: Renderer2
  ) {
    super(viewModel, elementRef, renderer2);
  }

  @Input() override cardBackground: CardData;
}
